/* ==========================================================================
   Couvision PDP - variant resolution, gallery, accessory add-on, multi-item add.
   Wired to Shopify product.variants JSON. Vanilla, deferred.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.pdp-m');
  if (!root) return;

  /* Klantteksten komen uit snippets/cv-teksten.liquid via window.cvTekst.
     In dit bestand staat daarom geen enkele zin: Liquid wordt in een .js-bestand
     niet gerenderd, dus een zin hier is principieel onvertaalbaar. Ontbreekt de
     helper (snippet niet gerenderd), dan komt de sleutelnaam terug; dat valt op
     bij het testen en zet nooit een verkeerde taal op het scherm. */
  var T = window.cvTekst || function (s) { return s; };

  var dataEl = document.querySelector('[data-pdp-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  var CUR = (dataEl && dataEl.getAttribute('data-currency')) || 'EUR';
  var LOC = (dataEl && dataEl.getAttribute('data-locale')) || 'nl-NL';

  var form = document.getElementById('pdp-form');
  var idInput = document.querySelector('[data-pdp-variant-id]');

  function money(cents) {
    try {
      var s = new Intl.NumberFormat(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      return s.replace(/,00$/, ',-');
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',-'); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function $(sel) { return document.querySelector(sel); }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  /* ---- Selected option state -------------------------------------------- */
  var groups = $all('[data-option-group]');
  var curId = idInput ? parseInt(idInput.value, 10) : null;
  var curVar = variants.filter(function (v) { return v.id === curId; })[0] || variants[0];
  var selected = curVar ? curVar.options.slice() : [];
  var currentBase = curVar ? curVar.price : 0;
  function accDelta() { var sum = 0; $all('[data-pdp-accessory]').forEach(function (ac) { if (ac.getAttribute('aria-checked') === 'true') { sum += parseInt(ac.getAttribute('data-acc-price'), 10) || 0; } }); return sum; }
  function showPrice(base) { var t = base + accDelta(); var el = document.querySelector('[data-pdp-price]'); if (el) el.textContent = money(t); var s = document.querySelector('[data-pdp-sticky-price]'); if (s) s.textContent = money(t); }

  groups.forEach(function (group) {
    var pos = parseInt(group.getAttribute('data-option-group'), 10);
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      /* Bij role="radio" hoort aria-checked; aria-pressed wordt daar genegeerd, dus
         een schermlezer hoorde wel "keuzerondje" maar nooit welke gekozen was. */
      group.querySelectorAll('[data-option-value]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      selected[pos - 1] = btn.getAttribute('data-option-value');
      var lbl = $('[data-pdp-option-label="' + pos + '"]');
      if (lbl) lbl.textContent = selected[pos - 1];
      resolve();
    });
  });

  function resolve() {
    var match = variants.filter(function (v) {
      for (var i = 0; i < selected.length; i++) { if (v.options[i] !== selected[i]) return false; }
      return true;
    })[0];

    if (!match) { setAvailable(false, T('pdp.niet_beschikbaar')); return; }
    if (idInput) idInput.value = match.id;

    if (window.history && window.history.replaceState) {
      var u = new URL(window.location); u.searchParams.set('variant', match.id); window.history.replaceState({}, '', u);
    }

    currentBase = match.price;
    showPrice(currentBase);

    var cmp = (match.compare_at_price && match.compare_at_price > match.price) ? match.compare_at_price : 0;
    toggleCompare(cmp, match.price);

    $all('[data-pdp-instalment]').forEach(function (el) { el.textContent = money(Math.round(match.price / 3)); });

    var line = $('[data-pdp-variant-line]');
    if (line) line.innerHTML = match.options.map(function (o, i) { return i === 0 ? '<b>' + esc(o) + '</b>' : ' · ' + esc(o); }).join('');

    if (match.featured_image && match.featured_image.src) {
      var img = $('[data-pdp-main-image]');
      if (img) { var src = match.featured_image.src; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900'; img.removeAttribute('srcset'); }
    }

    setAvailable(match.available, match.available ? T('pdp.in_winkelwagen') : T('pdp.uitverkocht'));
    updateStock(match.id);
  }

  /* ---- Stock indicator (>=5 in / 1-4 low / 0 out) ----------------------- */
  var stockEl = $('[data-pdp-stock]');
  var stockMap = {};
  try { stockMap = JSON.parse((stockEl && stockEl.getAttribute('data-stockmap')) || '{}'); } catch (e) { stockMap = {}; }
  /* De 'in'-regel is opgebouwd uit twee losse sleutels, zodat de vetgedrukte
     kop en de levertijd apart vertaald kunnen worden. esc() eromheen omdat dit
     als innerHTML de pagina in gaat. */
  function stockTekst(st) {
    if (st === 'low') return esc(T('pdp.bijna_uitverkocht'));
    if (st === 'out') return esc(T('pdp.tijdelijk_uitverkocht'));
    return '<span><b>' + esc(T('pdp.op_voorraad')) + '</b> ' + esc(T('pdp.zelfde_dag')) + '</span>';
  }
  function updateStock(id) {
    if (!stockEl) return;
    var st = stockMap[id] || 'in';
    stockEl.classList.remove('pdp-m__stock--in', 'pdp-m__stock--low', 'pdp-m__stock--out');
    stockEl.classList.add('pdp-m__stock--' + st);
    stockEl.innerHTML = '<span class="dot"></span>' + stockTekst(st);
  }

  function setText(sel, txt) { var el = $(sel); if (el) el.textContent = txt; }
  function toggleCompare(cmp, price) {
    var was = $('[data-pdp-compare]'), save = $('[data-pdp-save]'), sWas = $('[data-pdp-sticky-compare]');
    if (cmp) {
      if (was) { was.textContent = T('pdp.adviesprijs') + ' ' + money(cmp); was.hidden = false; }
      if (save) { save.textContent = T('pdp.bespaart') + ' ' + money(cmp - price); save.hidden = false; }
      if (sWas) { sWas.textContent = money(cmp); sWas.hidden = false; }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; if (sWas) sWas.hidden = true; }
  }
  function setAvailable(ok, label) {
    $all('[data-pdp-atc]').forEach(function (b) { if (ok) { b.removeAttribute('disabled'); } else { b.setAttribute('disabled', ''); } });
    $all('[data-pdp-atc-label]').forEach(function (s) { s.textContent = label; });
    /* voorraadregel in de mobiele balk meeschakelen met de gekozen variant */
    $all('[data-pdp-sticky-stock]').forEach(function (s) {
      s.textContent = ok ? T('pdp.op_voorraad_kort') : T('pdp.tijdelijk_uitverkocht');
      s.classList.toggle('is-uit', !ok);
    });
  }


  /* Gratis hoesje + screenprotector: uitklappen zodat de klant ziet wat hij krijgt */
  (function () {
    var knop = document.querySelector('[data-gift-open]');
    var pop = document.getElementById('giftpop');
    if (!knop || !pop) return;
    function open() {
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      knop.setAttribute('aria-expanded', 'true');
      var x = pop.querySelector('[data-gift-close]');
      if (x) x.focus();
    }
    function dicht() {
      pop.hidden = true;
      document.body.style.overflow = '';
      knop.setAttribute('aria-expanded', 'false');
      knop.focus();
    }
    knop.addEventListener('click', open);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-gift-close]')) dicht();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) dicht();
    });
  }());

  /* Uitleg-popups: opslagkeuze en inruilen. Zelfde gedrag als de hoesje-popup,
     maar met een eigen knop, zodat de klant zelf kan opzoeken wat hij nodig heeft. */
  function koppelPopup(openSel, popId, sluitSel) {
    var knoppen = $all(openSel);
    var pop = document.getElementById(popId);
    if (!knoppen.length || !pop) return;
    function dicht() {
      pop.hidden = true;
      document.body.style.overflow = '';
      knoppen.forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
    }
    knoppen.forEach(function (k) {
      k.addEventListener('click', function () {
        pop.hidden = false;
        document.body.style.overflow = 'hidden';
        k.setAttribute('aria-expanded', 'true');
        var x = pop.querySelector(sluitSel);
        if (x) x.focus();
      });
    });
    pop.addEventListener('click', function (e) { if (e.target.closest(sluitSel)) dicht(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) dicht(); });
  }
  koppelPopup('[data-opslag-open]', 'opslagpop', '[data-opslag-close]');

  /* ---- Gallery: thumbs + pijlen + lightbox (coolblue-stijl) --------------- */
  var galIndex = 0;
  var galMedia = [];
  (function () {
    var el = $('[data-pdp-media]');
    if (el) { try { galMedia = JSON.parse(el.textContent); } catch (e) { galMedia = []; } }
  }());
  function galShow(i) {
    var thumbs = $all('[data-pdp-thumb]');
    var n = Math.max(galMedia.length, thumbs.length, 1);
    galIndex = ((i % n) + n) % n;
    var img = $('[data-pdp-main-image]');
    var t = thumbs[galIndex];
    if (img) {
      img.src = t ? t.getAttribute('data-image') : (galMedia[galIndex] || img.src);
      img.removeAttribute('srcset');
    }
    thumbs.forEach(function (x, k) { x.setAttribute('aria-selected', k === galIndex ? 'true' : 'false'); });
    if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    var c = $('[data-pdp-count-current]'); if (c) c.textContent = galIndex + 1;
  }
  $all('[data-pdp-thumb]').forEach(function (t, k) {
    t.addEventListener('click', function () { galShow(k); });
  });
  $all('[data-pdp-nav]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      galShow(galIndex + parseInt(b.getAttribute('data-pdp-nav'), 10));
    });
  });

  /* Lightbox: klik op de hoofdfoto = groot bekijken */
  var lb = $('[data-pdp-lightbox]');
  if (lb && galMedia.length) {
    document.body.appendChild(lb); /* uit de galerij-stacking-context tillen: altijd boven header/sticky */
    var lbImg = $('[data-pdp-lightbox-image]');
    var lbCur = $('[data-pdp-lightbox-current]');
    function lbShow(i) {
      var n = galMedia.length;
      galIndex = ((i % n) + n) % n;
      lbImg.src = galMedia[galIndex];
      if (lbCur) lbCur.textContent = galIndex + 1;
    }
    function lbOpen() { lbShow(galIndex); lb.hidden = false; document.body.style.overflow = 'hidden'; }
    function lbClose() { lb.hidden = true; document.body.style.overflow = ''; galShow(galIndex); }
    var mainImg = $('[data-pdp-main-image]');
    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', lbOpen);
    }
    var lbc = $('[data-pdp-lightbox-close]'); if (lbc) lbc.addEventListener('click', lbClose);
    $all('[data-pdp-lightbox-nav]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); lbShow(galIndex + parseInt(b.getAttribute('data-pdp-lightbox-nav'), 10)); });
    });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(galIndex - 1);
      if (e.key === 'ArrowRight') lbShow(galIndex + 1);
    });
  }

  /* ---- Charger inforow: flip 'geen oplader' -> 'oplader meegeleverd' ----- */
  function updateChargerRow() {
    var row = $('[data-charger-row]'); if (!row) return;
    var added = false;
    $all('[data-pdp-accessory]').forEach(function (ac) {
      if (ac.getAttribute('aria-checked') === 'true' && ac.getAttribute('data-acc-charger') === 'true') added = true;
    });
    var txt = row.querySelector('[data-charger-text]');
    if (txt) { txt.textContent = added ? (txt.getAttribute('data-incl') || txt.textContent) : (txt.getAttribute('data-none') || txt.textContent); }
    row.classList.toggle('is-charger-added', added);
  }

  /* ---- Accessory add-ons (multi; single-select within a data-acc-group) -- */
  $all('[data-pdp-accessory]').forEach(function (card) {
    function toggle() {
      var willCheck = card.getAttribute('aria-checked') !== 'true';
      var grp = card.getAttribute('data-acc-group');
      if (grp && willCheck) {
        $all('[data-pdp-accessory][data-acc-group="' + grp + '"]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      }
      card.setAttribute('aria-checked', willCheck ? 'true' : 'false');
      showPrice(currentBase);
      updateChargerRow();
    }
    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
  });
  updateChargerRow();

  /* ---- Add to cart (main + optional accessory) -------------------------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      /* Deze tak kan op dit moment niet vuren: geen enkel sjabloon zet
         data-pdp-free-variant. Het cadeaublok op de productpagina is dus puur
         informatief en het gratis hoesje wordt bij het inpakken meegegeven,
         niet als regel in de winkelwagen. Wil je dat wel, zet dan het attribuut
         met de variant-id; dan werkt dit vanzelf. */
      var freeEl = document.querySelector('[data-pdp-free-variant]');
      if (freeEl) { var fid = parseInt(freeEl.getAttribute('data-pdp-free-variant'), 10); if (fid) items.push({ id: fid, quantity: 1 }); }
      $all('[data-pdp-accessory]').forEach(function (card) {
        if (card.getAttribute('aria-checked') === 'true') {
          var aid = parseInt(card.getAttribute('data-variant-id'), 10);
          if (aid) items.push({ id: aid, quantity: 1 });
        }
      });
      var btns = $all('[data-pdp-atc]');
      btns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) {
          /* Shopify zet de leesbare reden in description; die werd nooit gelezen
             en de klant belandde zonder uitleg op /cart. */
          return r.json().then(function (j) {
            var m = (j && (j.description || j.message)) || T('winkelwagen.mislukt');
            if (window.__cvToast) window.__cvToast(m); else alert(m);
          }).catch(function () {
            if (window.__cvToast) window.__cvToast(T('winkelwagen.mislukt'));
          });
        }
        return r.json().then(function () {
          if (window.__cvCartCount) window.__cvCartCount();
          if (window.__cvToast) window.__cvToast(T('winkelwagen.toegevoegd'));
        });
      }).catch(function () { form.submit(); })
        .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-disabled'); }); });
    });
  }
}());
